import Vue from 'vue';
import VueI18n from 'vue-i18n';
import englishText from '~/localization/text/en'; // English text-version is default and will be on every school

// Moment configuration
import moment from 'moment';
import LocalizationUtils from './LocalizationUtils';

Vue.use(VueI18n);

const localeFromPath = LocalizationUtils.getLocaleFromURL();
const locale = LocalizationUtils.isLocaleSupported(localeFromPath) ? localeFromPath : 'en';

// Is the selected locale different from the locale in the URL?
if (locale !== localeFromPath) {
    // This will redirect to the correct locale
    window.location.replace(LocalizationUtils.replaceLocaleInURL(locale));
}

// Configure moment js
const MOMENT_LOCALE_MAP: Record<string, string> = {
    en: 'en-gb',
    cn: 'zh-cn',
    jp: 'ja',
};
export const mapLocaleToMoment = (locale: string) => MOMENT_LOCALE_MAP[locale] || locale;
moment.locale(mapLocaleToMoment(locale));

LocalizationUtils.loadlLocaleMoment(mapLocaleToMoment(locale));

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: {
        en: englishText,
    },
});

LocalizationUtils.loadLocaleMessages(i18n, locale);

export default i18n;
